export default __webpack_public_path__ + "static/media/fsk-20-b.1d54ddc5.jpg";